<template>
	<div class="currentDropdown">
		<div class="currentPeriod" @click="showingOptions = !showingOptions">
			Visita
		</div>
		<div class="currentSelection range" @click="showingOptions = !showingOptions">
			<div class="row center currentSelection dateR">
				{{selectedVisit.text}}
			</div>
		</div>
		<div :class="contentClasses">
			<div
				class="option"
				v-for="visit in visitsDropdown"
				:key="`visit-${visit.value}`"
				@click="selectVisit(visit.value)"
			>
				{{visit.text}}
			</div>
		</div>
		<!-- <b-form-select v-model="selectedAcademicYearId" :options="academicYearsDropdown"/> -->
	</div>
</template>

<script>
import helpers from '@/helpers';
import mediator from '@/mediator';
export default {
	props: [],
	data () {
		return {
			showingOptions: false,
			visitsDropdown: [
				{
					text: 'Selecciona una visita',
					value: 0
				},
				{
					text: 'Visita 1',
					value: 1
				},
				{
					text: 'Visita 2',
					value: 2
				},
				{
					text: 'Visita 3',
					value: 3
				},
				{
					text: 'Visita 4',
					value: 4
				}
			]
		};
	},
	computed: {
		selectedVisit () {
			return this.$store.state.persistent.visit;
		},
		contentClasses () {
			let classes = ['currentContent'];
			if (!this.showingOptions) classes.push('hide');
			return classes;
		}
	},
	methods: {
		selectVisit (visitId) {
			let visit = this.visitsDropdown.find((item) => (item.value == visitId));
			mediator.coaching.setVisit(visit);
		}
	}
};
</script>

<style lang="scss" scoped>
@import "../../scss/global.scss";
.current {
	&Dropdown {
		border: 0.1rem solid $silkBlue;
		border-radius: 0.2rem;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: center;
		height: 5.5rem;
		width: 17rem;
		position: relative;
		cursor: pointer;
		/*&:after {
			content: "";
			width: 0;
			height: 0;
			position: absolute;
			top: 3.6rem;
			right: 1rem;
			border-left: 0.6rem solid transparent;
			border-right: 0.6rem solid transparent;
			border-top: 0.5rem solid $oxfordBlue;
			background: transparent;
		}*/
		& .hide {
			display: none;
		}
		&.disabled {
			border: 0.1rem solid $borderGrey;
			border-radius: 0.2rem;
			cursor: not-allowed;
			& > .currentPeriod {
				background-color: $liteGrey;
				color: $borderGrey;
			}
			& > .currentSelection {
				color: $borderGrey;
			}
		}
	}
	&Period {
		background-color: $oxfordBlue;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		font-size: $smallSize;
		font-weight: 700;
		line-height: 0;
		color: $blank;
		height: 2.4rem;
		width: 100%;
	}
	&Selection {
		background-color: $blank;
		display: flex;
		padding: 0 1rem;
		height: 3rem;
		justify-content: space-between;
		align-items: center;
		font-weight: 700;
		text-align: center;
		width: 100%;
		&>* {
			padding: 0;
			width: auto;
		}
		&.text {
			font-size: $mediumSize;
			color: $oxfordBlue;
			&.currentSelection {
				color: $borderGrey;
			}
			align: center;
		}
		&.visits {
			font-size: $smallSize;
			font-weight: 400;
			color: $silkBlue;
			margin-right: 2.6rem;
			&.currentSelection {
				color: $borderGrey;
			}
		}
		&.dateR {
			&>em {
				font-weight: 700;
				font-style: normal;
				margin: 0 1rem;
			}
			font-weight: 400;
		}
		&.range {
			justify-content: center;
		}
	}
	&Content {
		background-color: $blank;
		border: 0.1rem solid $silkBlue;
		display: flex;
		margin: 0;
		padding: 1rem;
		flex-direction: column;
		justify-content: flex-start;
		align-items: center;
		width: 100%;
		height: auto;
		position: absolute;
		top: 6.4rem;
		z-index: 5;
		&:before {
			content: "";
			width: 0;
			height: 0;
			position: absolute;
			top: -0.7rem;
			right: 12.4rem;
			border-left: 1rem solid transparent;
			border-right: 1rem solid transparent;
			border-bottom: 0.7rem solid $silkBlue;
			background: transparent;
		}
		&:after {
			content: "";
			width: 0;
			height: 0;
			position: absolute;
			top: -0.6rem;
			right: 12.6rem;
			border-left: 0.8rem solid transparent;
			border-right: 0.8rem solid transparent;
			border-bottom: 0.6rem solid $blank;
			background: transparent;
		}
	}
}

.option {
	border-bottom: 0.1rem solid $silkBlue;
	width: 100%;
	text-align: center;
	margin-bottom: 0.5rem;
	margin-top: 0.5rem;
	&:hover {
		padding: 0.8rem;
		color: $oxfordBlue;
		font-weight: bold;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/ui/FilterDropdownVisits.vue